import { render, staticRenderFns } from "./flightSearch.vue?vue&type=template&id=1b248d42&"
import script from "./flightSearch.vue?vue&type=script&lang=js&"
export * from "./flightSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports